// The default V1 palette and the Forcefield replacement that the v2_rebrand
// flag applies. The Forcefield values are the same as --color-orange and
// --color-pink in V2's Forcefield palette.
export const KEYHOLDING_PALETTE = {
  accent:  "#ffddcc",
  primary: "#fa5f00"
}

export const FORCEFIELD_PALETTE = {
  accent:  "#FFC2A9",
  primary: "#FF5714"
}
